export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Edit.vue?vue&type=template&id=59ebdc27&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Freight/Edit.vue?vue&type=template&id=59ebdc27&scoped=true
// module id = 2294
// module chunks = 31